import { useState, useRef } from "react";

import { Icon } from "common/ui/Icon";
import { Tooltip } from "common/ui/Tooltip";

import { useClickOutside } from "common/middleware/hooks";

import styles from "./MoreInfoIcon.module.scss";

interface Props {
  message: React.ReactNode,
}

export function MoreInfoIcon({ message }: Props) {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const icon = useRef(null);

  useClickOutside(icon, () => setIsTooltipVisible(false));

  return (
    <div className={styles.MoreInfoIcon}>
      <Icon
        className={styles.Icon}
        ref={icon}
        icon="moreInfo"
        onClick={() => setIsTooltipVisible(!isTooltipVisible)}
      />
      {isTooltipVisible && (
        <Tooltip className={styles.Tooltip}>
          {message}
        </Tooltip>
      )}
    </div>
  )
}
